import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step15 from './Step15-redux';

export default compose(
  withRouter,
  withNextStep
)(Step15);
